import { validateLatitudeLongitude } from '@deckee/utilities';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { moveMapToLocation } from '../../../../services/store/modules/app-controls';
import { getSelectedSignal } from '../../../../services/store/modules/signal';

const useSelectedSignalAsMapCenter = () => {
  const dispatch = useDispatch();

  const signal = useSelector(getSelectedSignal) || {};

  const { latitude, longitude } = signal;

  useEffect(() => {
    if (!validateLatitudeLongitude(latitude, longitude)) {
      return;
    }

    const mapOptions = {
      center: {
        lat: latitude,
        lon: longitude,
      },
    };

    dispatch(moveMapToLocation(mapOptions));
  }, [latitude, longitude, dispatch]);
};

export default useSelectedSignalAsMapCenter;
